export const getErrorMessage = (error?: string) => {
  let message = "Something went wrong. Please, try again";

  if (error?.includes("Invalid site key")) {
    message = "Invalid site key. Please, contact support";
  }
  return message;
};
